module.exports = __webpack_public_path__ + "img/7.05a6ef1c.jpg";